import React from "react";
import { Link } from "react-router-dom";
import { FaPhone } from "react-icons/fa"; // floating call button
import About from "../components/About";
import Products from "../components/Products";

export default function Home() {
  return (
    <main>
      {/* Hero */}
      <section className="hero">
        <div className="hero-overlay"></div>

        <div className="hero-inner">
          <h1 className="hero-title">Ruga's Café</h1>
          <p className="hero-subtitle">
            Bright coffee. Fresh bakes. Sunny vibes. Every day.
          </p>
          <Link
            to="/menu"
            className="buy-button"
            style={{ marginTop: "1rem" }}
          >
            Our Menu
          </Link>
        </div>
      </section>

      {/* Opening Times (banner) */}
      <section className="hours-banner">
        <div className="hours-inner centered-hours">
          <span className="hours-dot" aria-hidden="true" />
          <p className="hours-text">
            <strong>Open Mon to Friday:</strong> 5:00am – 2pm&nbsp;&nbsp;
            <strong>Open Sat:</strong> 5:00am – 11am
          </p>
        </div>
      </section>

      {/* About (component) */}
      <About />

      {/* Products (component replacing Specialities carousel) */}
      <Products />

      {/* Map */}
      <section id="find-us" className="map section-wrap">
        <div className="page-content">
          <h2>Find Us</h2>
          <div className="map-embed">
            <iframe
              title="Ruga's Café location"
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
              src="https://www.google.com/maps?q=4%2F445%20Victoria%20Road%20Taperoo%2C%20Adelaide%2C%20South%20Australia%205017&output=embed"
            />
          </div>
        </div>
      </section>

      {/* Floating Call Button */}
      <a
        className="fab-call"
        href="tel:+61883419000" /* TODO: replace with the café phone number */
        aria-label="Call Ruga's Café"
      >
        <FaPhone />
      </a>
    </main>
  );
}
